import { useAuthStore } from "@/stores/AuthStore";

export default function userIsRole(roleName) {

    const authStore = useAuthStore();
    const me = authStore.me;

    return !!(me && me.roles.filter(role => role.name === roleName).length > 0);
};